import React from 'react'
import { useSelector } from 'react-redux'
import { Box, Tooltip } from '@mui/material'
import DOMPurify from 'dompurify'
import useTooltipEnabled from 'Hooks/useTooltipEnabled'

interface PhotoProps {
  photos?: any
  assetUrl?: string
}

function stripHtmlTags(htmlString) {
  if(htmlString) return htmlString.replace(/<[^>]*>/g, '');
}

const Photos = ({ photos, assetUrl }: PhotoProps) => {
  const { locId } = useSelector((state: any) => state.location)
  const instagramWidth = '800px'
  const instagramHeight = '650px'
  const tooltipEnabled = useTooltipEnabled()

  return (
    <>
      {photos?.map((photo: any) => { 
        const accessibilityText = `${photo.title + '.'} ${
              photo.accessibility_description || stripHtmlTags(photo.description) || ''
            }`
        return (
          <div
            tabIndex={0}
            aria-label={accessibilityText}
          >
            <h3 tabIndex={-1}>{photo.title}</h3>
            <Box
              tabIndex={-1}
              component={'div'}
              sx={{
                maxWidth: '100%',
                maxHeight: '450px',
                background: '#f2f3f4',
                textAlign: 'center',
                overflow: 'scroll',
              }}
            >
              <Tooltip title={accessibilityText} placement='top' arrow disableHoverListener={!tooltipEnabled} disableFocusListener={!tooltipEnabled} disableTouchListener={!tooltipEnabled}>
              {photo.network !== 'instagram' ? (
                <Box
                  aria-role='presentation'
                  role='presentation'
                  tabIndex={-1}
                  component='img'
                  sx={{
                    maxHeight: '450px',
                    maxWidth: '100%',
                  }}
                  alt={photo.accessibility_description || 'Photo'}
                  src={`${assetUrl}/media/${locId}/photos/${
                    photo.photoid || photo.hotspotMediaId || photo.media_id
                  }/1024.jpg`}
                />
              ) : (
                <iframe
                  aria-hidden='true'
                  src={`https://www.instagram.com/p/${photo.url}/embed`}
                  title='Instagram video player'
                  frameBorder='0'
                  scrolling='true'
                  width={instagramWidth}
                  height={instagramHeight}
                  style={{
                    maxWidth: instagramWidth,
                    maxHeight: instagramHeight,
                    width: '100%',
                  }}
                  data-testid={`instagram-video-${photo.photoid}`}
                />
              )}
              </Tooltip>
            </Box>

            <p
              tabIndex={-1}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(photo.description, {
                  ADD_ATTR: ['target'],
                }),
              }}
            />
          </div>
        )
      })}
    </>
  )
}

export default Photos
